import { useStore } from 'vuex';
import { getDigitalDetailV2 } from '@/api/common';
import { queryRole } from '@/api/roleV2';
export default (() => {
  const store = useStore();
  // 获取用户文件信息
  const chooseRoleFiles = computed(() => store.state.role.chooseRoleFile);
  // 获取用户role列表信息
  const onwerAllRoleList = computed(() => store.state.role.onwerAllRoleList);
  // 当前选中的角色
  const curSelectRoleInfo = computed(() => store.state.role.curSelectRoleInfo);
  // 是否显示隐藏left
  const isShowLeft = computed(() => store.state.role.showLeftSlide);
  // 是否显示隐藏left set
  const setIsShowLeft = data => {
    store.commit('role/setShowLeftSlide', data);
  };
  const visible = computed(() => store.state.role.is_show_chat_toolltip);
  const set_visible = data => {
    store.commit('role/set_is_show_chat_toolltip', data);
  };
  const setChooseRoleFiles = data => {
    store.commit('role/setChooseRoleFiles', data);
  };
  const setonwerAllRoleList = data => {
    store.commit('role/setonwerAllRoleList', data);
  };
  const curDigitalInfo = computed(() => {
    var _store$state;
    return store === null || store === void 0 ? void 0 : (_store$state = store.state) === null || _store$state === void 0 ? void 0 : _store$state.role.curDigitalInfo;
  });
  const setCurSelectRoleInfo = data => {
    store.commit('role/setCurSelectRoleInfo', data);
  };
  const setDigitalDetail = async () => {
    const res = await getDigitalDetailV2({
      digitalManId: curSelectRoleInfo.value.digitalManId
    });
    setCurDigitalInfo(res);
  };
  const setCurDigitalInfo = data => {
    store.commit('role/setCurDigitalInfo', data);
  };
  const getRoleList = async () => {
    const res = await queryRole({});
    if (res.code == 200) {
      setonwerAllRoleList(res.data);
    }
  };
  const avatarList = computed(() => {
    return onwerAllRoleList.value;
  });
  const initAllRoleList = async () => {
    await getRoleList();
    if (onwerAllRoleList.value.length > 0) {
      const canlist = onwerAllRoleList.value.filter(vo => vo.status == 2);
      if (canlist.length > 0) {
        setCurSelectRoleInfo(canlist[0]);
      } else {
        ElMessage.warning('暂无可用角色！');
        return;
      }
      setDigitalDetail();
    }
  };
  return {
    isShowLeft,
    setIsShowLeft,
    chooseRoleFiles,
    onwerAllRoleList,
    curSelectRoleInfo,
    setonwerAllRoleList,
    setChooseRoleFiles,
    setCurSelectRoleInfo,
    setDigitalDetail,
    curDigitalInfo,
    setCurDigitalInfo,
    getRoleList,
    avatarList,
    initAllRoleList,
    set_visible,
    visible
  };
});